import { styled } from '@mui/material';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import * as Preact from 'preact';
import { useTranslations } from './utils/TranslationsWrapper';

export type Props = {
    close: () => void;
    show: boolean;
};

// reposition the snackbar default class so it doesn't lie over the AppBar
const StyledSnackbar = styled(Snackbar)(({ theme }) => ({
    '&.MuiSnackbar-anchorOriginTopRight': {
        top: '86px',
        right: '20px',
        position: 'absolute',
        marginLeft: '20px',
        zIndex: theme.zIndex.modal,
        boxSizing: 'border-box',
        borderRadius: '8px',
    },
}));

export const Component = (p: Props) => {
    const { t } = useTranslations();
    return (
        <StyledSnackbar
            open={p.show}
            onClose={p.close}
            ClickAwayListenerProps={{ mouseEvent: false }}
            autoHideDuration={null}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <Alert
                severity="error"
                onClose={p.close}
                sx={{
                    /* For some reason the standard Alert doesn't vertically center the content. This makes it behave */
                    '.MuiAlert-message': { display: 'flex', alignItems: 'center' },
                    '.MuiAlert-action': { display: 'flex', alignItems: 'center', padding: 0 },
                    '.MuiAlert-icon': { display: 'flex', alignItems: 'center' },
                }}
            >
                {t('error.render.alert')}
            </Alert>
        </StyledSnackbar>
    );
};
